import { HideOverflow } from 'components';
import { LongSectionP05P08, InterBoxP08 } from '../IntendendComponents';

const Prac08 = () => {
  return (
    <HideOverflow>
      <LongSectionP05P08 />
      <InterBoxP08 />
      <LongSectionP05P08 />
      <InterBoxP08 />
      <LongSectionP05P08 />
    </HideOverflow>
  );
};

export default Prac08;
